var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vcr-logo"},[_c('router-link',{attrs:{"to":{ name: _vm.RouterName.brandSwitcher }}},[_c('img',{staticClass:"vcr-logo__img",attrs:{"src":_vm.logoUrl,"alt":_vm.altName}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }